import MobileDeviceRules from './MobileDeviceRules';
export default MobileDeviceRules;
